import { logoLinksSearchStyles as styles } from "@iewcasia/Overrides/Widgets/Header/LogoLinksSearch";
import { colorStrings, mediaQueriesBP } from "@iewcasia/Utilities/variables";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

const height = 25;

styles.container = {
    ...styles.container,
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        padding: 20px 0;

        ${mediaQueriesBP.minLG} {
            padding: 0 0 20px;
        }
    `,
};

styles.logoWrapper = {
    css: css`
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 5px;
        flex-wrap: nowrap;
        padding: 0;
        margin: 0 24px;

        flex-grow: 1;
        text-align: left;

        ${mediaQueriesBP.minMD} {
            margin: 0;
            min-width: 300px;
        }

        img {
            height: ${height}px;
            width: 60px;
            margin: 0;
            aspect-ratio: 16/9;
            object-fit: contain;
            max-width: 60px;

            ${mediaQueriesBP.minMD} {
                width: 80px;
                height: calc(${height}px * 2);
                max-height: 50px;
                max-width: 80px;
            }
        }
    `,
};

styles.searchMenuWrapper = {
    css: css`
        text-align: right;
        padding: 0;
    `,
};

styles.logoGridContainer = {
    ...styles.logoGridContainer,
    gap: 0,
    css: css`
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        justify-content: flex-start;

        .logo-item:has(img) + .logo-item:has(img) {
            border-left: 2px solid ${getColor(colorStrings.commonGlobalGray03)};
            padding-inline-start: 10px;
            height: ${height}px;

            ${mediaQueriesBP.minMD} {
                height: calc(${height}px * 2);
            }
        }
    `,
    offsetCss: css`
        align-items: center;
        gap: 10px;
    `,
};

styles.logoGridItem = {
    css: css`
        flex: 1 1 auto;
        padding: 0;
        width: auto;
        max-width: max-content;
    `,
};

styles.imageGridItem = {
    css: css`
        flex: 1 1 auto;
        padding: 0;
        width: auto;
        max-width: max-content;
    `,
};

styles.countrySelectorGridItem = {
    css: css`
        flex: 1 1 auto;
        padding: 0;
        width: auto;
        max-width: max-content;
        margin: 0 0 0 auto !important;
        min-width: 100px;

        ${mediaQueriesBP.minLG} {
            display: none;
        }
    `,
};
